
import React from 'react';

export const ProjectsIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    apartment
  </span>
);